var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsOffereasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_414)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.0484,
    cy: 55.0484,
    r: 24.5119,
    stroke: "url(#paint0_linear_645_414)",
    strokeWidth: 13.073
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0088 83.9634L103.113 34.3301",
    stroke: "black",
    strokeWidth: 19.6095
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5137 78.3848L47.5607 60.3984",
    stroke: "black",
    strokeWidth: 19.6095,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5713 60.4395L58.3549 76.615C59.5241 78.3687 62.0231 78.5735 63.4622 77.0335L90.3358 48.2754",
    stroke: "url(#paint1_linear_645_414)",
    strokeWidth: 11.3838,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_645_414",
    x1: 69.5726,
    y1: 34.3495,
    x2: 51.0908,
    y2: 92.1052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37C0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E0799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_645_414",
    x1: 79.6447,
    y1: 53.571,
    x2: 72.3133,
    y2: 84.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37C0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E0799"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsOffereasy);
export default __webpack_public_path__ + "static/media/products_offereasy.9ff4ae6bde2c929cf38a81e805aabb27.svg";
export { ForwardRef as ReactComponent };